import { Box, Paper, Typography } from "@material-ui/core";
import React, { useContext } from "react";
import SettingsContext from "src/context/SettingsContext";
export default function DataNotFound({ data, message }) {
  const themeSeeting = useContext(SettingsContext);
  return (
    <Box
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        // width: "100%",
        padding: "35px 25px",
      }}
      component={Paper}
      // mt={2}
    >
<img

  src={
    themeSeeting.settings.theme === "LIGHT"
      ? `${process.env.REACT_APP_IMAGE_BASE_URL}/nodataFoundLight.svg`
      : `${process.env.REACT_APP_IMAGE_BASE_URL}/nodataFound.svg`
  }
  width={95}
  style={{ marginBottom: "15px" }}
/>
      <Typography
        variant="body2"
        color="secondary"
        style={{ fontWeight: "400" }}
      >
        {message || "You have no Records to display"}
      </Typography>
    </Box>
  );
}
